import { FamilyStep, STEPS } from 'redux/familyBookingSlice';

export interface FamilyStepConfig {
  title: string;
  showsModeDropdown: boolean;
  allowsOverflow: 'always' | 'mobile' | 'never';
}

export const FAMILY_STEP_CONFIGS: Record<FamilyStep, FamilyStepConfig> = {
  [STEPS.CONTACT_LOOKUP]: {
    title: 'Contact Details',
    showsModeDropdown: true,
    allowsOverflow: 'mobile',
  },
  [STEPS.VERIFICATION]: {
    title: 'Enter Verification Code',
    showsModeDropdown: true,
    allowsOverflow: 'never',
  },
  [STEPS.SIGN_IN]: {
    title: 'Sign in',
    showsModeDropdown: true,
    allowsOverflow: 'never',
  },
  [STEPS.SIGN_UP]: {
    title: 'Sign up',
    showsModeDropdown: true,
    allowsOverflow: 'mobile',
  },
  [STEPS.CONTACT_DETAILS]: {
    title: 'Just a few details',
    showsModeDropdown: true,
    allowsOverflow: 'never',
  },
  [STEPS.SCHEDULE]: {
    title: 'Schedule',
    showsModeDropdown: true,
    allowsOverflow: 'mobile',
  },
  [STEPS.SLOT_SELECTION]: {
    title: 'Select time',
    showsModeDropdown: false,
    allowsOverflow: 'always',
  },
};
